module.exports = __webpack_public_path__ + "static/icons/icon-ski-hire-273e095d183028ea2ea29b7ab10c1eca.svg";